import { AxiosService } from 'services';
export function GetCurrentBrandService() {

  return AxiosService().get(`brand/current-brand`)
    .then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
}
